import { Identifiable } from './identifiable';

export class AssessmentDistributionInfo {
  contactId: Identifiable;
  deletedPersonnelRecordId: Identifiable;
  riskAssessmentDistributionId: Identifiable;
  riskAssessmentDistributionMemberId: Identifiable;
  riskAssessmentId: Identifiable;
}
